/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef, useState } from 'react'
import { useGLTF } from '@react-three/drei'
import { TextureLoader } from 'three';
import { useLoader } from '@react-three/fiber';



export function Finalboards({mode},props) {
  const { nodes, materials } = useGLTF('/Finalboards.glb')

  const newsboardref = useRef()
  const newsboardrefone = useRef()
  const newsboardreftwo = useRef()
  const newsboardrefthree = useRef()
  const newsboardreffour = useRef()
  const newsboardreffive = useRef()

  const material = new THREE.MeshBasicMaterial({color: "cream"})

  const materialblack = new THREE.MeshBasicMaterial({color: "orange"})


  // one
  function hoverinone() {

    console.log("hovered")
    
    newsboardref.current.material = materialblack
    
  }

  function hoveroutone() {
 
    console.log("hovered out")
    
    newsboardref.current.material = material

  }
  
  // two
  function hoverintwo() {

    console.log("hovered")
    
    newsboardreffive.current.material = materialblack
    
  }

  function hoverouttwo() {
 
    console.log("hovered out")
    
    newsboardreffive.current.material = material

  }

  // three
  function hoverinthree() {

    console.log("hovered")
    
    newsboardrefone.current.material = materialblack
    
  }

  function hoveroutthree() {
 
    console.log("hovered out")
    
    newsboardrefone.current.material = material

  }

  // four
  function hoverinfour() {

    console.log("hovered")
    
    newsboardrefthree.current.material = materialblack
    
  }

  function hoveroutfour() {
 
    console.log("hovered out")
    
    newsboardrefthree.current.material = material

  }

  // five
  function hoverinfive() {

    console.log("hovered")
    
    newsboardreffour.current.material = materialblack
    
  }

  function hoveroutfive() {
 
    console.log("hovered out")
    
    newsboardreffour.current.material = material

  }

  // six
  function hoverinsix() {

    console.log("hovered")
    
    newsboardreftwo.current.material = materialblack
    
  }

  function hoveroutsix() {
 
    console.log("hovered out")
    
    newsboardreftwo.current.material = material

  }

  const textureone = useLoader(TextureLoader, "../img/gallery.png");
  textureone.colorSpace = THREE.SRGBColorSpace;
  textureone.flipY = false
  textureone.wrapS = THREE.RepeatWrapping
  textureone.wrapT = THREE.RepeatWrapping
  textureone.repeat.set(1, 1);
  textureone.anisotropy = 128

  const texturetwo = useLoader(TextureLoader, "../img/signfive.png");
  texturetwo.colorSpace = THREE.SRGBColorSpace;
  texturetwo.flipY = false
  texturetwo.wrapS = THREE.RepeatWrapping
  texturetwo.wrapT = THREE.RepeatWrapping
  texturetwo.repeat.set(1, 1);
  texturetwo.anisotropy = 128

  const texturethree = useLoader(TextureLoader, "../img/signtwo.jpg");
  texturethree.colorSpace = THREE.SRGBColorSpace;
  texturethree.flipY = false
  texturethree.wrapS = THREE.RepeatWrapping
  texturethree.wrapT = THREE.RepeatWrapping
  texturethree.repeat.set(1, 1);
  texturethree.anisotropy = 128

  const texturefour = useLoader(TextureLoader, "../img/signfour.jpg");
  texturefour.colorSpace = THREE.SRGBColorSpace;
  texturefour.flipY = false
  texturefour.wrapS = THREE.RepeatWrapping
  texturefour.wrapT = THREE.RepeatWrapping
  texturefour.repeat.set(1, 1);
  texturefour.anisotropy = 128

  const texturefive = useLoader(TextureLoader, "../img/signthree.jpg");
  texturefive.colorSpace = THREE.SRGBColorSpace;
  texturefive.flipY = false
  texturefive.wrapS = THREE.RepeatWrapping
  texturefive.wrapT = THREE.RepeatWrapping
  texturefive.repeat.set(1, 1);
  texturefive.anisotropy = 128

  const texturesix = useLoader(TextureLoader, "../img/signone.jpg");
  texturesix.colorSpace = THREE.SRGBColorSpace;
  texturesix.flipY = false
  texturesix.wrapS = THREE.RepeatWrapping
  texturesix.wrapT = THREE.RepeatWrapping
  texturesix.repeat.set(1, 1);
  texturesix.anisotropy = 128


  const texturematerial = new THREE.MeshBasicMaterial({map: textureone})

  const texturematerialtwo = new THREE.MeshBasicMaterial({map: texturetwo})
  
  const texturematerialthree = new THREE.MeshBasicMaterial({map: texturethree})

  const texturematerialfour = new THREE.MeshBasicMaterial({map: texturefour})

  const texturematerialfive = new THREE.MeshBasicMaterial({map: texturefive})

  const texturematerialsix = new THREE.MeshBasicMaterial({map: texturesix})


  return (
    <group {...props} dispose={null}>
      <mesh
        name="RGP_portfoliobanners_geo"
        castShadow
        receiveShadow
        ref={newsboardreffive}
        onClick={()=>{window.open('https://gotembatourism.jp/',"_blank")}}
        geometry={nodes.RGP_portfoliobanners_geo.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="newsboard"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
          }}
          // onClick={()=>{
          //   props.newsClick()
          // }}

        onPointerEnter={hoverinone}
        onPointerOut={hoveroutone}  
        castShadow
        receiveShadow
        geometry={nodes.newsboard.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="newsbanner"
        castShadow
        receiveShadow
        ref={newsboardref}
        onClick={()=>{window.open('https://mtfujitrailstation.com/',"_blank")}}
        geometry={nodes.newsbanner.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="RGP_portfoliobanners_geo_one"
        castShadow
        receiveShadow
        geometry={nodes.RGP_portfoliobanners_geo_one.geometry}
        material={texturematerialtwo}
        position={[-237.099, 16.884, -367.561]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="RGP_portfoliobanners_geo001"
        castShadow
        receiveShadow
        ref={newsboardrefone}
        onClick={()=>{window.open('https://mtfujitrailstation.com/',"_blank")}}
        geometry={nodes.RGP_portfoliobanners_geo001.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="RGP_portfoliobanners_geo002"
        castShadow
        receiveShadow
        ref={newsboardreftwo}
        onClick={()=>{window.open('https://mtfujitrailstation.com/',"_blank")}}
        geometry={nodes.RGP_portfoliobanners_geo002.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="RGP_portfoliobanners_geo003"
        castShadow
        receiveShadow
        ref={newsboardrefthree}
        onClick={()=>{window.open('https://www.youtube.com/watch?v=AsRFvTsp21I',"_blank")}}
        geometry={nodes.RGP_portfoliobanners_geo003.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="RGP_portfoliobanners_geo004"
        castShadow
        receiveShadow
        ref={newsboardreffour}
        onClick={()=>{window.open('https://www.youtube.com/watch?v=pAdsD6ZIL-0',"_blank")}}
        geometry={nodes.RGP_portfoliobanners_geo004.geometry}
        material={material}
        position={[-277.933, 0.107, -289.609]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="RGP_portfoliobanners_geo_fifth"
        castShadow
        receiveShadow
        geometry={nodes.RGP_portfoliobanners_geo_fifth.geometry}
        material={texturematerialthree}
        position={[-311.453, 16.884, -369.319]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="RGP_portfoliobanners_geo_two"
        castShadow
        receiveShadow
        geometry={nodes.RGP_portfoliobanners_geo_two.geometry}
        material={texturematerialfour}
        position={[-277.17, 16.884, -288.639]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="RGP_portfoliobanners_geo_four"
        castShadow
        receiveShadow
        geometry={nodes.RGP_portfoliobanners_geo_four.geometry}
        material={texturematerialfive}
        position={[-331.502, 16.884, -329.909]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="RGP_portfoliobanners_geo_three"
        castShadow
        receiveShadow
        geometry={nodes.RGP_portfoliobanners_geo_three.geometry}
        material={texturematerialsix}
        position={[-351.558, 16.884, -290.438]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="newsbanner_actual"
        castShadow
        receiveShadow
        geometry={nodes.newsbanner_actual.geometry}
        material={texturematerial}
        position={[-257.096, 16.884, -328.09]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.497}
      />
      <mesh
        name="board_one"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
          }}

        onPointerEnter={hoverintwo}
        onPointerOut={hoverouttwo}   
        castShadow
        receiveShadow
        geometry={nodes.board_one.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="board_two"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
          }}

        onPointerEnter={hoverinthree}
        onPointerOut={hoveroutthree} 
        castShadow
        receiveShadow
        geometry={nodes.board_two.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="board_four"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
        }}

        onPointerEnter={hoverinfour}
        onPointerOut={hoveroutfour} 
        castShadow
        receiveShadow
        geometry={nodes.board_four.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="board_five"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
          }}

        onPointerEnter={hoverinfive}
        onPointerOut={hoveroutfive} 
        castShadow
        receiveShadow
        geometry={nodes.board_five.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
      <mesh
        name="board_three"
        onPointerOver={()=>{
            document.body.style.cursor = 'pointer'
          }}
        onPointerLeave={()=>{
            document.body.style.cursor = 'auto'
          }}

        onPointerEnter={hoverinsix}
        onPointerOut={hoveroutsix}  
        castShadow
        receiveShadow
        geometry={nodes.board_three.geometry}
        material={materials['rgp_tex.001']}
        position={[-278.341, -0.193, -289.964]}
        rotation={[Math.PI / 2, 0, -0.716]}
        scale={0.535}
      />
    </group>
  )
}

useGLTF.preload('/Finalboards.glb')
